import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

export const USER_ID_KEY = 'optimizelyEndUserId';
export const DEFAULT_EXPIRATION_IN_DAYS = 60;

export const getUserUuid = () => {
  let uuid = Cookies.get(USER_ID_KEY);

  if (!uuid) {
    uuid = uuidv4();

    Cookies.set(USER_ID_KEY, uuid, {
      expires: DEFAULT_EXPIRATION_IN_DAYS,
      secure: true,
    });
  }

  return uuid;
};
